import React, {Component, PropTypes} from 'react';
import {
  assign,
  merge,
  find,
  get,
  omit,
  trim,
  isEmpty
} from 'lodash';
import { concat } from '../../../../../../lib/strings';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import DateInput from '../../../../../../common/components/DateInput';
import CheckList from '../../../../../../common/components/c_CheckList';
import ToggleButton from '../../../../../../common/components/c_ToggleButton';
import { convertToMenuItems, getLookupValue } from '../../../../../../redux/helpers/staticData';
import cx from 'classnames';

export default class jobRequestWorksheetSchedule extends Component {

  static propTypes = {
    jobRequest: PropTypes.object.isRequired,
    primaryContact: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      jobRequest: props.jobRequest,
      dirty: false
    };

    this.handleDropdown = ::this.handleDropdown;
    this.handleTextField = ::this.handleTextField;
    this.handleToggleButton = ::this.handleToggleButton;
    this.handleDateProperties = ::this.handleDateProperties;

    this.menuItems = {
        numberOfMonth: [
          {
            primaryText: '6',
            subElement: null,
            value: 6
          }, {
            primaryText: '7',
            subElement: null,
            value: 7
          }, {
            primaryText: '8',
            subElement: null,
            value: 8
          }, {
            primaryText: '9',
            subElement: null,
            value: 9
          }, {
            primaryText: '10',
            subElement: null,
            value: 10
          }, {
            primaryText: '11',
            subElement: null,
            value: 11
          }, {
            primaryText: '1 yr',
            subElement: null,
            value: 12
          }, {
            primaryText: '2 yrs',
            subElement: null,
            value: 24
          }

        ],
        hoursPerWeek: [
          {
            primaryText: 20,
            subElement: null,
            value: 20
          }, {
            primaryText: 25,
            subElement: null,
            value: 25
          }, {
            primaryText: 30,
            subElement: null,
            value: 30
          }, {
            primaryText: 35,
            subElement: null,
            value: 35
          }, {
            primaryText: 37.5,
            subElement: null,
            value: 37.5
          }, {
            primaryText: 40,
            subElement: null,
            value: 40
          }

        ],
        yesNo:[{value: true, primaryText: 'Yes', subElement: null}, {value: false, primaryText: 'No', subElement: null}],
        daysPerWeek: this.props.staticData.dayAvailableTypes,
        preferredStartTime: convertToMenuItems(this.props.staticData.workHours.slice(0, 25), 'id', 'name', 'subElement'),
        preferredEndTime: convertToMenuItems(this.props.staticData.workHours.slice(6, this.props.staticData.workHours.length), 'id', 'name', 'subElement'),
        jobType: convertToMenuItems(this.props.staticData.jobTypes, 'id', 'name', 'subElement'),
        timezone: convertToMenuItems(this.props.staticData.timezoneList, 'id', 'name')
      };


  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequest) {
      this.setState(merge({}, this.state, {jobRequest: nextProps.jobRequest}));
    }
  }

  handleChange(prop) {

    return (event, value) => {

      this.setState({dirty: true});

      const jobRequest = assign({}, this.state.jobRequest);
      jobRequest[prop] = value;

      this.setState({jobRequest});
    };
  }

	handleDateProperties(prop, label) {
		return {
      'data-id': 'date-' + prop,
			defaultValue: this.state.jobRequest[prop],
			floatingLabelText: label,
			onChange: this.handleChange(prop),
      floatingLabelFixed: true,
      disabled: this.props.disabled,
		};
	}

  handleDropdown(prop, label, menuItems) {
    return {
      'data-id': prop,
      value: this.state.jobRequest[prop],
      onChange: this.handleChange(prop),
      floatingLabelText: label,
      menuItems,
      canAutoPosition: true,
      disabled: this.props.disabled,
    };
  }

  handleTextField(prop, label) {

    return {
      'data-id': prop,
      value: this.state.jobRequest[prop],
      onChange: this.handleChange(prop),
      floatingLabelText: label,
      floatingLabelFixed: true,
      disabled: this.props.disabled,
    };
  }

	handleToggleButton(prop, label) {
		return {
			'data-id': 'tooglebutton-' + prop,
			value: this.state.jobRequest[prop],
			onChange: this.handleChange(prop),
			floatingLabelText: label || null,
      disabled: this.props.disabled,
		};
	}


  handleSave = () => {

    if(this.state.dirty === false) {
      return;
    }

    this
      .props
      .handleSave({
        company: {
          id: this.props.primaryContact.company.id,
        },
        jobrequest: omit(this.state.jobRequest, ['primaryContact'])
      }).then(() => {
        this.setState({dirty: false });
      });

  }

  jobRequestLocation = () => {
    const {
      jobRequest = {}
    } = this.state;
    const user = get(this.props.primaryContact, 'user', {});
    const contactState = get(find(this.props.staticData.stateList, {id: user.state}), 'primaryText');
    const jobState = get(find(this.props.staticData.stateList, {id: jobRequest.state}), 'primaryText');

    if (jobRequest.city) {
      return concat(
            [
              concat([jobRequest.address, jobRequest.address2], ' '),
              jobRequest.city,
              concat([jobState, jobRequest.zip], ' ')
            ], ', ');
    }

    return concat(
          [
            user.address,
            user.city,
            concat([contactState, user.zip], ' ')
          ], ', ');
  }

  render() {
    const {props} = this;
    const contactUser = props.primaryContact.user;
    const contactState = get(find(props.staticData.stateList, {id: contactUser.state}), 'primaryText');

    const jobType = getLookupValue(props.staticData, 'jobTypes', {id: this.state.jobRequest.jobTypeId});
    const isProjectType = jobType && jobType.hardcodelink === 'PROJECT';

    return (
      <div className='job-request-worksheet-schedule'>
        <h1 className='heading'>Schedule</h1>
        <div className='grid'>

           <div className='row'>

              <div className='col'>
                <div className='read-only-field'>
                  <div className='label'>Job Office Reporting Location</div>
                  <div className='value'>{ this.jobRequestLocation() }</div>
                </div>
              </div>

              <div className='col'>
                <DropDownMenu {...this.handleDropdown('timezone', 'Job Time Zone', this.menuItems.timezone)}/>
              </div>

            <div className='col'></div>
          </div>

          <div className='row'>

            <div className='col'>
              <div className='row'>

                <div className='col'>
                  <DropDownMenu {...this.handleDropdown('jobTypeId', 'Type of Job', this.menuItems.jobType)}/>
                </div>

                <div className='col'>
                   <DateInput className='half-width' autoOk minDate={new Date()} {...this.handleDateProperties('dateStarted', 'Expected Start Date')} />
                </div>

              </div>
            </div>

            <div className='col'>
                <CheckList {...this.handleDropdown('workdays', 'Days of the Week', this.menuItems.daysPerWeek)} />
            </div>

            <div className='col'>
              <div className='row'>

                <div className='col'>
                  <div className='row'>

                    <div className='col'>
                      <DropDownMenu  {...this.handleDropdown('estimatedHoursPerWeek', 'Hrs. Week', this.menuItems.hoursPerWeek)}/>
                    </div>

                   <div className='col'>
                      {isProjectType && <DropDownMenu {...this.handleDropdown('numberOfMonths', 'Months', this.menuItems.numberOfMonth)}/>}
                    </div>

                  </div>
               </div>

                 <div className='col'>
                 {isProjectType && <DateInput className='half-width' autoOk minDate={new Date()} {...this.handleDateProperties('dateEnded', 'Expected End Date')} />}
                </div>

              </div>
            </div>


          </div>
          <div className='row'>

            <div className='col'>
              <div className='row'>
                <div className='col'> <DropDownMenu {...this.handleDropdown('startTime', 'Pref. Start Time', this.menuItems.preferredStartTime)}/> </div>
                <div className='col'> <DropDownMenu {...this.handleDropdown('endTime', 'Pref. End Time', this.menuItems.preferredEndTime)}/> </div>
              </div>
            </div>

            <div className='col'>
              <ToggleButton	menuItems={this.menuItems.yesNo} 	{...this.handleToggleButton('offHoursConsidered', 'Work Can Be Performed Outside of Business Hours')} 	/>
            </div>

             <div className='col'>
              {
                this.state.jobRequest.estimatedHoursPerWeek >= 40
                &&
                <ToggleButton  menuItems={this.menuItems.yesNo} 	{...this.handleToggleButton('partTimeWahvesConsidered', 'Consider Two Wahves')} 	/>
              }
            </div>

          </div>
          {this.props.disabled ? null :  <div className='row'>
            <div className='col'>
              <FlatButton
                className={cx('button-save', {disabled: !this.state.dirty})}
                onClick={this.handleSave}
                data-id='save'
                label='save'/>
            </div>
          </div> }
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/Schedule/index.js